export default [
    {
      title: 'menu.Landing',
      icon: 'MonitorIcon',
      tagVariant: 'light-warning',
      route: 'landing'
    },
  ]